var $document = $(document);

$.fn.showModal = function () {
  return $(this).modal({
    backdrop: true,
    keyboard: true,
    show: true,
  });
};

$(function () {
  $document.on(
    'click.modal',
    '.modal button.exit, .modal a.close, .modal a.cancel',
    function (event) {
      if ($body.attr('id') === 'dialogs') {
        window.close();
      } else {
        $(this).closest('.modal').modal('hide');
      }
      return false;
    }
  );
  $document.on('click.help', '[data-help]', function (event) {
    $('#dialog-' + $(this).attr('data-help')).showModal();
    return false;
  });
});

// hack to fix bootstrap compatiability bug when select2s appears in a bootstrap modal dialog
// See https://github.com/twbs/bootstrap/issues/6996#issuecomment-23617382 for more details.
$.fn.modal.Constructor.prototype.enforceFocus = function () {
  var that = this;
  $(document).on('focusin.modal', function (e) {
    if (
      that.$element[0] !== e.target &&
      !that.$element.has(e.target).length &&
      // custom override to ensure focus isn't stollen off select2 elements:
      !$(e.target).closest('.select2-drop')
    ) {
      that.$element.focus();
    }
  });
};
